/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentFieldHistoryRequest } from '../../models/agent-field-history-request';
import { AgentFieldHistoryResponse } from '../../models/agent-field-history-response';

export interface PostApiAgentV1IdHistory$Plain$Params {

/**
 * The unique identifier of the agent.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload for agent history retrieval.
     */
    body?: AgentFieldHistoryRequest
}

export function postApiAgentV1IdHistory$Plain(http: HttpClient, rootUrl: string, params: PostApiAgentV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentFieldHistoryResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAgentV1IdHistory$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentFieldHistoryResponse>;
    })
  );
}

postApiAgentV1IdHistory$Plain.PATH = '/private/v1/agents/{id}/history';
